import { Link } from 'react-router-dom';
import { utcCalendarDaysElapsedSince } from '../lib/subscription';

type Props = {
  subscriptionPastDueAt?: string | null;
};

/**
 * Shown when `businesses.subscription_status` is `past_due` (synced from Stripe webhooks).
 */
export default function SubscriptionPastDueBanner({ subscriptionPastDueAt }: Props) {
  const elapsed = utcCalendarDaysElapsedSince(subscriptionPastDueAt);
  const daysPastDuePhrase =
    elapsed == null
      ? null
      : elapsed === 0
        ? 'Past due as of today'
        : elapsed === 1
          ? '1 day past due'
          : `${elapsed} days past due`;

  return (
    <div
      role="alert"
      className="shrink-0 w-full bg-red-600 px-3 py-2 text-center text-sm font-medium text-white border-b border-red-800"
    >
      <span>
        {daysPastDuePhrase != null
          ? `${daysPastDuePhrase}. Payment may have failed — `
          : 'Your subscription payment failed or is past due — '}
      </span>
      <Link
        to="/admin-subscription-management"
        className="underline font-semibold decoration-2 underline-offset-2 hover:text-red-100"
      >
        Update billing
      </Link>
    </div>
  );
}
